import { TAccountNavigationMenuItem } from '@pb/shared/ui/molecules/account-navigation-menu';
import { getEnvironmentSettings } from '@pb/services';

const { baseUrl, messages } = getEnvironmentSettings();

export const accountNavigationMenuItems: TAccountNavigationMenuItem[] = [
    {
        label: 'Dashboard',
        icon: 'home',
        href: `${baseUrl}/seller#!dashboard`,
    },
    {
        label: 'Properties',
        icon: 'soldBoard',
        children: [
            { href: `${baseUrl}/properties`, label: 'Your properties' },
            {
                href: `${baseUrl}/valuation-reason`,
                label: 'Book a valuation',
            },
            {
                href: `${baseUrl}/instant-instruct/find-your-address`,
                label: 'Instruct Purplebricks',
            },
            {
                href: `${baseUrl}/search/property-for-sale?page=1&sortBy=2&searchType=ForSale&searchRadius=2&soldOrLet=false&latitude=&longitude=&betasearch=true`,
                label: 'Property search',
            },
            {
                href: `${baseUrl}/seller#!manageSearch`,
                label: 'Saved properties',
            },
        ],
    },
    {
        label: 'Messages',
        icon: 'messageText',
        href: messages,
    },
    {
        label: 'Diary',
        icon: 'soldBoard',
        href: `${baseUrl}/seller#!manageDiary`,
    },
    {
        label: 'Viewings',
        icon: 'calendar',
        children: [
            {
                href: `${baseUrl}/seller#!manageViewings`,
                label: 'Manage existing viewings',
            },
            {
                href: `${baseUrl}/seller#!manageDiary/viewAvailability`,
                label: 'Manage availability',
            },
        ],
    },
    {
        label: 'Feedback',
        icon: 'message',
        href: `${baseUrl}/seller#!manageFeedback`,
    },
    {
        label: 'Offers',
        icon: 'banknote',
        href: `${baseUrl}/seller#!manageOffers`,
    },
    {
        label: 'Mortgages',
        icon: 'valuation',
        children: [
            {
                href: `https://www.purplebricks.co.uk/financial-services/mortgages`,
                label: 'Learn more',
            },
        ],
    },
    {
        label: 'Legal Services',
        icon: 'hammer',
        children: [
            {
                href: `${baseUrl}/seller#!serviceOverview`,
                label: 'Overview',
            },
            {
                href: `https://www.yourconveyancer.co.uk`,
                label: 'Scotland Conveyancing services',
            },
        ],
    },
];
